import { useState } from 'react'
import { Upload } from 'lucide-react'
import BulkUploadModal from '../../components/upload/BulkUploadModal'
import { Card } from '../ui'

export default function DemoData({ branches, onAddEntry, onImported }) {
  const [showUpload, setShowUpload] = useState(false)

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
      <Card title="Bulk CSV import">
        <div className="px-4 py-4">
          <p className="text-sm text-gray-500 mb-4">
            Import completed daily entries from CSV into any organization — the same
            validate → preview → import flow as before, now living in HQ.
          </p>
          <button onClick={() => setShowUpload(true)}
            className="flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white text-sm font-semibold px-4 py-2 rounded-lg transition">
            <Upload className="w-4 h-4" /> Upload CSV
          </button>
        </div>
      </Card>

      <Card title="Demo seeding" hint="supabase/demo_seed_branches.sql">
        <div className="px-4 py-4">
          <p className="text-sm text-gray-500">
            To stand up the 3 demo branches (Downtown / Lekki / Ikeja) with tanks and pumps,
            run <span className="font-mono text-xs">demo_seed_branches.sql</span> in the Supabase
            SQL Editor, then import <span className="font-mono text-xs">petrotrack_demo_2weeks.csv</span> here.
            A one-click in-app seeder is a Phase 4 candidate.
          </p>
        </div>
      </Card>

      {showUpload && (
        <BulkUploadModal
          branches={branches}
          onAddEntry={onAddEntry}
          onImported={onImported}
          onClose={() => setShowUpload(false)}
        />
      )}
    </div>
  )
}
